module.exports = __webpack_public_path__ + "699b5e4d436ed32f5ca6e2971c9aaf17.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/diyicaijin_c.png
// module id = 288
// module chunks = 3